/*
 * Copyright (c) 2024. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import React from "react";
import {useTranslation} from "react-i18next";
import clsx from "clsx";

interface ReservationDataCollectionInfoCardProps {
    disable?: boolean;
}

const ReservationDataCollectionInfoCard = (props: ReservationDataCollectionInfoCardProps) => {
    const {t} = useTranslation();
    return (
        <div className={clsx("ReservationDataCollectionInfoCard text-xs md:text-base flex flex-col gap-y-4")}>
            <div>
                {t(
                    "For insurance reasons, we need to collect personal data when entering the ArboPark. We must collect this information on the instruction of the insurance company so that insurance coverage can be provided."
                )}
            </div>
            <div>{t("To make the check-in process on site as quick as possible, we kindly ask you to enter all visitor data online before your visit")}</div>
            <b className={"font-semibold"}>{t("This will save you a lot of time during check-in!")}</b>
        </div>
    );
};

export default ReservationDataCollectionInfoCard;
